import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/clients";
import * as types from "./types";
import * as actions from "./actions";
import history from "../../routes/History";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import {
  adminCompanyClientRoutes,
  COMPANY_DETAILS_CLIENTS_TAB,
} from "../../containers/Admin-portal/ClientManagement/adminCompanyClientRoutes";

const goToCompanyClientsTab = (companyId) => {
  if (!companyId) {
    return ROUTE_PATHS.companiesList;
  }

  return adminCompanyClientRoutes.companyDetailsTabLocation(
    companyId,
    COMPANY_DETAILS_CLIENTS_TAB,
  );
};

// Create Client
function* createClientSaga({ payload }) {
    try {
        const companyId = payload?.company_id;
        const response = yield call(apis.createClient, payload);
        yield put(actions.createClientResponse(response.data));
        const message = response?.data?.message;
        if (message) yield call(showSuccessMsg, message, true);

        const createdClient = response.data?.data;
        if (companyId && createdClient?.id) {
            yield history.push({
                pathname: adminCompanyClientRoutes.view(companyId, createdClient.id),
                state: { clientData: createdClient, companyId },
            });
            return;
        }

        yield history.push(goToCompanyClientsTab(companyId));
    } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred";
        yield call(showErrorMsg, errorMessage);
    }
}

// List Clients
function* getClientsListSaga({ payload }) {
    try {
        const response = yield call(apis.getClientsList, payload);

        yield put(
            actions.getClientsResponse({
                list: response.data.data || [],
                meta: response.data.meta || {
                    currentPage: +response.headers["current-page"] || 1,
                    count: +response.headers["total-count"] || 0,
                    pages: +response.headers["total-pages"] || 1
                },
            })
        );
    } catch (error) {
        console.error("Error fetching clients:", error);
    }
}

// Get Client by ID
function* getClientSaga({ payload }) {
    try {
        const response = yield call(apis.getClientById, payload);
        yield put(actions.getClientResponse(response.data.data));
    } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred";
        yield call(showErrorMsg, errorMessage);
    }
}

// List All Clients
function* getAllClientsSaga() {
    try {
        const response = yield call(apis.getAllClients);
        yield put(actions.getAllClientsResponse(response.data.data));
    } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred";
        yield call(showErrorMsg, errorMessage);
    }
}

// Update Client
function* updateClientSaga({ payload }) {
    try {
        const { id, data, companyId } = payload;
        const response = yield call(apis.updateClient, id, data);
        const updatedClient = response.data.data;
        yield put(actions.updateClientResponse(updatedClient));
        const message = response?.data?.message;
        if (message) yield call(showSuccessMsg, message, true);

        if (companyId) {
            yield history.push({
                pathname: adminCompanyClientRoutes.view(companyId, id),
                state: { clientData: updatedClient, companyId },
            });
            return;
        }

        yield history.push(goToCompanyClientsTab(companyId));
    } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred";
        yield call(showErrorMsg, errorMessage);
    }
}

export default function* ClientsSagas() {
    yield takeEvery(types.CREATE_CLIENT_REQUEST, createClientSaga);
    yield takeEvery(types.GET_CLIENTS_REQUEST, getClientsListSaga);
    yield takeEvery(types.GET_CLIENT_REQUEST, getClientSaga);
    yield takeEvery(types.GET_ALL_CLIENTS_REQUEST, getAllClientsSaga);
    yield takeEvery(types.UPDATE_CLIENT_REQUEST, updateClientSaga);
}
